<template>
  <div
    :class="{
      'operation-layout': true,
      'show-for-medium': hamburgerOpen,
      'operation-layout--dashboard' : isDashboard
    }"
  >
    <div class="operation-layout__header header-nav-wrapper show-for-medium">
      <header class="header-nav">
        <div class="header-nav__left">
          <div class="hide-for-large">
            <button
              type="button"
              @click="hamburgerOpen = true"
            >
              <HamburgerSvg />
            </button>
          </div>

          <div
            v-if="currentOrganisation"
            class="show-for-large"
          >
            <Popper
              v-model:open="menuOpen"
              placement="bottom-start"
            >
              <div class="menu menu--dropdown">
                <ul class="menu__items">
                  <li class="menu-item menu-item--dropdown">
                    <router-link
                      class="menu-item__link"
                      :to="{ name: 'plants', params: { organisationId } }"
                    >
                      <UseSvg
                        class="icon icon--back-organisation"
                        name="arrow_left_16"
                      />
                      <div class="menu-item__label">
                        {{ currentOrganisation.name }}
                      </div>
                    </router-link>
                  </li>
                  <li><hr class="menu__divider"></li>
                  <li
                    v-for="operation in currentOrganisation.operations_without_division"
                    :key="operation.id"
                    class="menu-item menu-item--dropdown"
                  >
                    <router-link
                      class="menu-item__link"
                      :to="{ name: 'operation', params: { organisationId, operationId: operation.id } }"
                      @click.passive="closeMenus"
                    >
                      <div class="menu-item__label">
                        {{ operation.name }}
                      </div>
                    </router-link>
                  </li>
                  <template
                    v-for="division in divisionsWithOperations"
                    :key="division.name"
                  >
                    <li class="menu__section-title typo-tiny">
                      {{ division.name }}
                    </li>
                    <li
                      v-for="operation in division.operations"
                      :key="operation.id"
                      class="menu-item menu-item--dropdown"
                    >
                      <router-link
                        class="menu-item__link"
                        :to="{ name: 'operation', params: { organisationId, operationId: operation.id } }"
                        @click.passive="closeMenus"
                      >
                        <div class="menu-item__label">
                          {{ operation.name }}
                        </div>
                      </router-link>
                    </li>
                  </template>
                </ul>
              </div>

              <template #trigger>
                <div class="operation-dropdown typo-list-item">
                  <div
                    v-if="currentOrganisation"
                    class="operation-dropdown__logo"
                  >
                    <OrganisationLogo
                      :organisation="currentOrganisation"
                      :size="32"
                    />
                  </div>
                  <div
                    v-if="currentOperation"
                    class="operation-dropdown__name"
                  >
                    {{ currentOperation.name }}
                  </div>
                  <div class="operation-dropdown__icon">
                    <UseSvg
                      class="icon icon--small"
                      name="arrow_down_16"
                    />
                  </div>
                </div>
              </template>
            </Popper>
          </div>
        </div>

        <div
          v-if="currentOperation"
          class="header-nav__center header-nav__center--left-align hide-for-large"
        >
          <h1 class="header-nav__title typo-ignore typo-nav-item">
            {{ currentOperation.name }}
            <template v-if="activeMenuItem">
              <span> / </span>
              {{ activeMenuItem.label }}
            </template>
          </h1>
        </div>

        <div class="header-nav__center show-for-large">
          <div class="menu">
            <ul class="menu__items">
              <li
                v-for="item of mainNavItems"
                :key="item.label"
                class="menu-item"
              >
                <router-link
                  :activeClass="item.exact ? '' : 'menu-item__link--active'"
                  :class="{
                    'menu-item__link': true,
                    'menu-item__link--active': item.active,
                  }"
                  :exactActiveClass="item.exact ? 'menu-item__link--active' : ''"
                  :to="item.to"
                >
                  <div class="menu-item__label">
                    {{ item.label }}
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="header-nav__right">
          <UserAdminNavigation
            v-if="currentOrganisation && adminMenuItems"
            :adminMenuItems="adminMenuItems"
            :currentUser="currentUser?.full_name"
            :policy="currentOrganisation.policy"
          />
        </div>
      </header>
    </div>

    <router-view />
  </div>

  <div :class="{ 'mobile-menu-container hide-for-large': true, 'mobile-menu-container--shown': hamburgerOpen }">
    <div
      class="mobile-menu-overlay"
      @click="hamburgerOpen = false"
    />
    <div class="mobile-menu">
      <div class="mobile-menu__header">
        <div
          class="mobile-menu__close"
          @click="hamburgerOpen = false"
        >
          <CloseSvg />
        </div>
      </div>

      <div class="mobile-menu__menu">
        <div class="menu menu--hamburger">
          <ul class="menu__items">
            <li class="menu-item typo-list-item menu-item--hamburger">
              <router-link
                class="menu-item__link"
                :to="{ name: 'plants', params: { organisationId } }"
              >
                <div class="menu-item__label-icon">
                  <UseSvg
                    class="icon icon--small"
                    name="arrow_left_16"
                  />
                </div>
                <div class="menu-item__label">
                  {{ currentOrganisation && currentOrganisation.name }}
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="menu menu--hamburger">
          <ul class="menu__items">
            <li class="menu-item menu-item--hamburger">
              <Popper
                v-model:open="menuOpen"
                placement="bottom-end"
              >
                <div class="menu menu--dropdown">
                  <ul
                    v-if="currentOrganisation"
                    class="menu__items"
                  >
                    <li
                      v-for="operation in currentOrganisation.operations_without_division"
                      :key="operation.id"
                      class="menu-item typo-list-item menu-item--dropdown"
                    >
                      <router-link
                        class="menu-item__link"
                        :to="{ name: 'operation', params: { organisationId, operationId: operation.id } }"
                        @click.passive="closeMenus"
                      >
                        <div class="menu-item__label">
                          {{ operation.name }}
                        </div>
                      </router-link>
                    </li>
                    <template
                      v-for="division in divisionsWithOperations"
                      :key="division.name"
                    >
                      <li class="menu__section-title typo-tiny">
                        {{ division.name }}
                      </li>
                      <li
                        v-for="operation in division.operations"
                        :key="operation.id"
                        class="menu-item typo-list-item menu-item--dropdown"
                      >
                        <router-link
                          class="menu-item__link"
                          :to="{ name: 'operation', params: { organisationId, operationId: operation.id } }"
                          @click.passive="closeMenus"
                        >
                          <div class="menu-item__label">
                            {{ operation.name }}
                          </div>
                        </router-link>
                      </li>
                    </template>
                  </ul>
                </div>

                <template #trigger>
                  <div
                    v-if="currentOrganisation"
                    class="operation-dropdown typo-list-item"
                  >
                    <div class="operation-dropdown__logo">
                      <OrganisationLogo :organisation="currentOrganisation" />
                    </div>
                    <div
                      v-if="currentOperation"
                      class="operation-dropdown__name"
                    >
                      {{ currentOperation.name }}
                    </div>
                    <div class="operation-dropdown__icon">
                      <UseSvg
                        class="icon icon--small"
                        name="arrow_down_16"
                      />
                    </div>
                  </div>
                </template>
              </Popper>
            </li>
          </ul>
        </div>

        <div class="menu menu--hamburger">
          <ul class="menu__items">
            <li
              v-for="item of mainNavItems"
              :key="item.label"
              class="menu-item menu-item--hamburger"
            >
              <router-link
                class="menu-item__link"
                :to="item.to"
                @click.passive="closeMenus"
              >
                <div class="menu-item__label">
                  {{ item.label }}
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="menu menu--hamburger hide-for-medium">
          <ul class="menu__items">
            <li
              v-for="item of hamburgerMenuItems"
              :key="item.label"
              class="menu-item menu-item--hamburger"
            >
              <router-link
                v-if="item.to"
                class="menu-item__link"
                :to="item.to"
              >
                <div class="menu-item__label">
                  {{ item.label }}
                </div>
              </router-link>
              <a
                v-else
                class="menu-item__link"
                :href="item.path || 'javascript:void(0);'"
              >
                <div class="menu-item__label">
                  {{ item.label }}
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
export default { name: 'OperationLayout' };
</script>

<script setup>
import { computed, inject, provide, ref } from 'vue';
import { useRoute } from 'vue-router';
import I18n from 'i18n-js';

// Utils
import { profileMenuItems } from '@/functions/navigation';
import { useOperation } from '@/functions/use_remote_object';
import onAppEvent from '@/functions/on_app_event';
import isDesktop from '@/functions/responsive';

// Components
import Footer from '@/components/generic/footer.vue';
import UserAdminNavigation from '@/components/navigation/user_admin_navigation.vue';
import OrganisationLogo from '@/components/organisations/organisation_logo.vue';
import Popper from '@/components/generic/popper.vue';
import UseSvg from '@/components/generic/use_svg.vue';

// Icons
import CloseSvg from '@/images/close.svg';
import HamburgerSvg from '@/images/hamburger.svg';

const props = defineProps({
  organisationId: { type: String, required: true },
  operationId: { type: String, required: true },
});

const route = useRoute();

const currentUser = inject('currentUser');

const currentOrganisation = inject('currentOrganisation');
const currentOperation = useOperation(props);
const menuOpen = ref(false);
const hamburgerOpen = ref(false);

const adminMenuItems = computed(() => {
  if (!currentOperation.value) return null;

  let items = [];
  if (currentOperation.value.policy.manage_users) {
    items.push({
      label: I18n.t('nav.manage_users'),
      to: { name: 'allUsersScoped', params: { type: 'plants' } }
    });
  }
  if (currentOperation.value.policy.edit) {
    items.push({
      label: I18n.t('nav.configuration'),
      to: {
        name: isDesktop() ? 'configurationPlants' : 'configuration',
        params: {
          organisationId: props.organisationId,
          operationId: props.operationId,
        }
      },
    });
  }
  return items;
});

const mainNavItems = computed(() => [
  { label: I18n.t('nav.dashboard'), to: { name: 'operation' }, exact: true, active: ['operation', 'operations'].includes(route.name) },
  { label: I18n.t('nav.inspections'), to: { name: 'inspections', params: { scope: 'inspections' } }, active: ['inspection', 'inspections'].includes(route.name) },
  { label: I18n.t('nav.issues'), to: { name: 'regions', params: { issueType: 'plant' } }, active: ['region', 'regions', 'regionsTypeHme', 'regionsTypeHmes'].includes(route.name) },
  { label: I18n.t('nav.tasks'), to: { name: 'tasks' }, active: ['task', 'tasks'].includes(route.name) },
  { label: I18n.t('nav.monitoring_plans'), to: { name: 'plans', params: { scope: 'plans' } }, active: ['plan', 'plans'].includes(route.name) }
]);
const activeMenuItem = computed(() => {
  let matched = route.matched;
  return mainNavItems.value
    .find(item => matched.find(r => r.name === item.to.name));
});
const hamburgerMenuItems = computed(() => [
  ...adminMenuItems.value || [],
  ...profileMenuItems(I18n),
]);
const divisionsWithOperations = computed(() => {
  return currentOrganisation.value?.divisions?.filter(d => d.operations.length > 0) || [];
});
const isDashboard = computed(() => route.name === 'operation');

provide('currentOperation', currentOperation);

onAppEvent('hamburgerOpen', () => hamburgerOpen.value = true);

function closeMenus() {
  hamburgerOpen.value = false;
  menuOpen.value = false;
}
</script>
